module.exports = __webpack_public_path__ + "static/media/all-day-breakfast-hero-desktop.4ea89e82.jpg";